module.exports = __webpack_public_path__ + "img/setup-light.874c06f9.svg";